module.exports = __webpack_public_path__ + "static/img/derek_lai.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/derek_lai.jpg
// module id = asA4
// module chunks = 0